export default "__VITE_ASSET__BB3BkQaS__"